enum Mutations {
}

export default Mutations;
